import { Content } from "@pathwright/ui/src/components/content/Content"
import styled from "styled-components"
import { ButtonBlockButton } from "./ui"

const ButtonViewWrap = styled(Content.Container)`
  /* Override Block styles */
  .BlockText p,
  .ContentText,
  .MetaText {
    // ignore blocks styles
    color: #292e35 !important;
  }
`

const ButtonView = ({ data }) => {
  return (
    <ButtonViewWrap flexForPrint={true}>
      <Content.Text style={{ textAlign: "center", padding: "0.5em 0" }}>
        <ButtonBlockButton
          link={data.link}
          label={data.buttonLabel}
          openInNewTab={data.openInNewTab}
        />
      </Content.Text>
    </ButtonViewWrap>
  )
}

export default ButtonView
